import { useState } from 'react';

import { Button } from '../../cdl/Button/Button';
import { Modal } from '../../cdl/Modal/Modal';
import { Text } from '../../cdl/Text/Text';
import { TextArea } from '../../cdl/TextArea/TextArea';
import { CharacterCount } from '../../common/CharacterCount/CharacterCount';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

import { useCharacterLimit } from './useCharacterLimit';

const CHARACTER_LIMIT = 280;

export const CommentPopup = ({ open, onDismiss, onSubmit, requestInProgress, headline, description, inputLabel }) => {
    const [message, setMessage] = useState('');

    const { limitReached } = useCharacterLimit({
        characterLength: message.length,
        characterLimit: CHARACTER_LIMIT,
    });

    const onFormSubmit = (event) => {
        event.preventDefault();

        onSubmit(message || undefined);
    };

    return (
        <Modal isOpen={open} onDismiss={onDismiss} scrollable={false}>
            <Box display="grid" rowGap={16} padding={24}>
                <Text variant="title">{headline}</Text>

                <Text color="foreground.subtle">{description}</Text>

                <form onSubmit={onFormSubmit}>
                    <Box display="grid" rowGap={16}>
                        <TextArea
                            label={inputLabel}
                            placeholder={translate('approvalRequest.commentInputPlaceholder')}
                            onChange={(event) => setMessage(event.target.value)}
                            value={message}
                            rows={4}
                        />

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <CharacterCount count={message.length} limit={CHARACTER_LIMIT} />

                            <Button
                                emphasis="high"
                                isLoading={requestInProgress}
                                disabled={requestInProgress || limitReached}
                            >
                                {translate('approvalRequest.declinePopup.submitButton')}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        </Modal>
    );
};
